export default {
	BASE_STORAGE: process.env.REACT_APP_BASE_STORAGE,
	BASE_API: process.env.REACT_APP_BASE_API,
	BASE_PUBLIC: process.env.REACT_APP_BASE_PUBLIC,
	TIMEZONE: 'America/Caracas',
	LEVELS: {
		ADMIN: 1,
		MODERATOR: 2,
		CLIENT: 3
	},
	USER: {
		VERIFIED: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
		STATUS: {
			PENDING: 0,
			ACTIVE: 1,
			INACTIVE: 2,
		}
	},
	MODULES: {
		
	},
	IDENTITY_VERIFICATION_RESULT: {
	    YES: 1,
	    NO: 0,
	    UNFINISH: -1
	},
	S3: {
	    YES: 1,
	    NO: 0
	},
	CHANGE_VERIFICATION_TYPES: {
		DOCUMENT: 1,
		FACE: 2,
		LIVENESS: 3,
		RESULT: 4,
	},
	ORIGINS: {
		ANDROID: 1,
		IOS: 2,
		WEB: 3
	},
	IS_VEHICLE: {
	    YES: 1,
	    NO: 0
	},
	MESSAGE_LENGTH: {
	    SHORT: 1,
	    MEDIUM: 2,
	    LARGE: 3
	},
	DOCUMENT_TYPES: {
		V: 1,
		E: 2,
		G: 3,
		J: 4,
		PASSPORT: 5
	},
	BRAVEALO_DOCUMENT_TYPES: {
		ID: 1,
		PASSPORT: 2,
		VEHICLE_CARD: 3
	},
	PHONECODES: ['0412','0414','0424','0416','0426','0422'],
	INFORMATION_TYPES: {
	    QUESTIONS: 1,
	    SUGGESTIONS: 2,
	    RESTRICTIONS: 3
	},
	REFERRAL_SETTING_TYPE: {
	    AMOUNT: 1,
	    PERCENT: 2
	},
	REFERRAL_STATUS: {
	    PENDING: 0,
	    PAID: 1
	},
	AGENTS: {
		SUPPORT: 1,
		SALES: 2,
		CUSTOMER_SERVICE: 3,
		APPOINTMENTS: 4
	},
	WAYS: {
		FACEBOOK: 1,
		INSTAGRAM: 2,
		WHATSAPP: 3,
		TIKTOK: 4,
		API: 5
	}
}